import { Badge } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

export const MutationBadge = ({
  disableTooltip,
  size,
}: {
  disableTooltip?: boolean;
  size?: 'normal' | 'lg';
}) => {
  const innerIcon = (
    <Badge
      variant="info"
      className={classnames(
        'm-1 mr-2 flex shrink-0 items-center justify-center',
        { 'size-6 text-base': size === 'lg' },
        { 'size-4 text-xs': size === undefined || size === 'normal' },
      )}
      data-testid="mutation-type-badge"
    >
      M
    </Badge>
  );
  return disableTooltip ? (
    <>{innerIcon}</>
  ) : (
    <Tooltip openDelay={200} label="Mutation">
      {innerIcon}
    </Tooltip>
  );
};
